export const businessDirectoryOptoutData ={
   
    "headingText": "If {companyName} is your company and you would like to remove it from the D&B Business Directory, please {contactLink}",
    "linkClasses": "link",
    "linkHref": "https://support.dnb.com/?PROD=SMBDIRECTORY",
    "linkNewWindow": true,
    "linkText": "contact us."
}